
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
window.$ = window.jQuery = require('jquery');
global.$ = global.jQuery = require('jquery');
window.Vue = require('vue');

import VueLocalStorage from 'vue-ls';
import VueSweetAlert from 'vue-sweetalert';
import cookieConsent from "./cookie";

require ('jquery-ui');
require ('jquery-ui/ui/widgets/accordion');
require('./bootstrap');
require('./counter');
require('./owl.carousel');
require('./custom');
require('./sidebar');
require('./accordion.js');
require('./lightbox.js');

Vue.use(VueSweetAlert);
Vue.use(VueLocalStorage, {
    namespace: 'cer-btp_',
    name: 'ls',
    storage: 'local',
});

Vue.component('visitor-form', require('./components/VisitorForm.vue'));
Vue.component('backdrop-loader', require('./components/BackdropLoader.vue'));

window.App = new Vue({
    el: '#popup-visitor',
});

cookieConsent.processCookieConsent({
    business_name: 'CER BTP',
    ga_tracking_id: window.GA_TRACKING_ID
});



// WEBPACK FOOTER //
// ./resources/assets/js/app.js